'use strict';

var App = require('app');
var AppState = require('app_state');
var BaseFilterController = require('components/devices/controllers/base_filter_controller');
var Consts = require('consts');
var GroupListView = require('components/devices/views/groups/group_list_view');
var GroupInviteDialogView = require('components/devices/views/groups/group_invite_dialog_view');
var GroupView = require('components/devices/views/groups/group_view');
var UserGroupView = require('components/devices/views/groups/user_group_view');
var HomeController = require('components/home/home_controller');
var Notification = require('utils/notification');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var Groups = require('models/groups');

var GroupsController = BaseFilterController.extend({
    displayGroupList: function (showUserGroups) {
        // request groups
        var self = this;

        AppState.requireColumns(function () {
            var listReq = App.request(
                'groups:list',
                showUserGroups ? Consts.GroupReqMode.User : Consts.GroupReqMode.Standard
            );
            $.when(listReq).done(function (data) {
                self.groupsView = new GroupListView({
                    controller: self,
                    collection: data,
                    nrModels: data.length,
                    showUserGroups: showUserGroups,
                });
                App.showContentView(self.groupsView);
            });
        });
    },

    showUserGroup: function (model) {
        var self = this;
        AppState.requireAllCapabilities(function () {
            var dlgData = {
                name: model.get('name'),
                filter: model.get('filter'),
                selectedFields: _.map(model.get('fields'), function (item) {
                    var fieldInfo = AppState.availableColumnData(item) || {};
                    return Misc.fieldToColumnName(item, fieldInfo.field_type);
                }),
                accessRights: model.get('access_rights'),
            };

            var dlg = new UserGroupView({
                controller: this,
                isDefault: model.get('is_default'),
                data: dlgData,
                cb: function (newContent) {
                    model.set('name', newContent.name);
                    model.set('filter', newContent.filter);
                    model.set('access_rights', newContent.accessRights);
                    model.set(
                        'fields',
                        _.map(newContent.selectedFields, function (m) {
                            return Misc.columnNameToField(m);
                        })
                    );
                    model.save(
                        {},
                        self.getSaveGroupCB(function () {
                            return dlg;
                        }, true)
                    );
                },
            });
            App.showModal(dlg);
        });
    },

    showGroup: function (model) {
        var self = this;
        // build data for the dialog
        var newFilter = $.extend(true, {}, model.get('filter'));

        var dlgData = {
            name: model.get('name'),
            forAll: model.get('for_all') ? 1 : 0,
            selectedDevices: newFilter.devices,
            showSelectDevices: newFilter.devices && newFilter.devices.length > 0,
            filter: newFilter,
        };
        delete newFilter.devices;

        var dlg = new GroupView({
            controller: this,
            data: dlgData,
            cb: function (newContent) {
                var modelData = self.getGroupData(newContent);
                _.each(['filter', 'name', 'for_all'], function (key) {
                    model.set(key, modelData[key]);
                });

                model.save(
                    {},
                    self.getSaveGroupCB(function () {
                        return dlg;
                    })
                );
            },
        });
        App.showModal(dlg);
    },

    getGroupData: function (data) {
        var filter = $.extend(true, {}, data.filter);
        if (data.showSelectDevices) {
            filter = { devices: data.selectedDevices };
        }

        return {
            name: data.name,
            filter: filter,
            for_all: parseInt(data.forAll) > 0,
        };
    },

    getUserGroupData: function (data) {
        var filter = $.extend(true, {}, data.filter);
        if (data.showSelectDevices) {
            filter = { devices: data.selectedDevices };
        }

        return {
            name: data.name,
            filter: filter,
            fields: _.map(data.selectedFields, function (item) {
                return Misc.columnNameToField(item);
            }),
            access_rights: data.accessRights,
            user_group: true,
        };
    },

    getSaveGroupCB: function (dlgFct, showUserGroups) {
        var self = this;
        var dlg = dlgFct();
        return {
            success: function () {
                App.hideModal();
                self.displayGroupList(showUserGroups);
            },
            error: function (self, err) {
                err = err || {};
                dlg.setError(err.responseJSON || { error: 'general_error' });
            },
        };
    },

    addGroup: function () {
        var self = this;
        var dlg = new GroupView({
            controller: this,
            cb: function (data) {
                // create new model
                var newGroup = new Groups.Model(self.getGroupData(data));
                newGroup.save(
                    {},
                    self.getSaveGroupCB(function () {
                        return dlg;
                    })
                );
            },
        });
        App.showModal(dlg);
    },

    addUserGroup: function () {
        var self = this;
        AppState.requireAllCapabilities(function () {
            // request the default group for the company
            $.when(App.request('groups:list', Consts.GroupReqMode.CompanyDefault)).done(function (defGrp) {
                var defaultFields = [];
                if (defGrp && defGrp.length) {
                    defaultFields = defGrp.models[0].get('fields');
                }

                var dlg = new UserGroupView({
                    controller: this,
                    data: {
                        selectedFields: _.map(defaultFields, function (item) {
                            var fieldInfo = AppState.availableColumnData(item) || {};
                            return Misc.fieldToColumnName(item, fieldInfo.field_type);
                        }),
                    },
                    cb: function (data) {
                        // create new model
                        var newUserGroup = new Groups.Model(self.getUserGroupData(data));
                        newUserGroup.save(
                            {},
                            self.getSaveGroupCB(function () {
                                return dlg;
                            }, true)
                        );
                    },
                });
                App.showModal(dlg);
            });
        });
    },

    setFilter: function (filter, view) {
        var self = this;
        BaseFilterController.prototype.setFilter.apply(this, [filter]);
        this.useDeviceList(function (list) {
            self.showGroupDevices(list, view);
        });
    },

    showGroupDevices: function (list, view) {
        view.showGroupDevices(list);
    },

    inviteToGroups: function (list) {
        var view = new GroupInviteDialogView({
            groups: list,
            cb: function (code) {
                if (code === 400) {
                    Notification.show(
                        'warning',
                        I18N.TR('Keine Aktion'),
                        I18N.TR('Einige eingeladenen Nutzer sind bereits Mitglieder.')
                    );
                } else {
                    Notification.show(
                        'success',
                        I18N.TR('Erfolg'),
                        I18N.TR('E-Mail zur Bestätigung der Gruppenfreigabe wurde versendet.')
                    );
                }
                // reload page
                Backbone.history.loadUrl(Backbone.history.fragment);
            },
        });
        App.showModal(view);
    },
});

module.exports = GroupsController;
